import moment from 'moment';

export default class SessionService {
  constructor(
    storageProvider,
    saveItemFun,
    getItemFunc,
    removeItemFunc,
    prefix,
    impersonated,
    token,
    session,
    user,
    tenant,
    lastTenant
  ) {
    this.storageProvider = storageProvider;
    this.saveItemFun = saveItemFun;
    this.getItemFunc = getItemFunc;
    this.removeItemFunc = removeItemFunc;
    this.prefix = prefix;

    this.keys = {};
    this.keys.impersonated = impersonated;
    this.keys.token = token;
    this.keys.session = session;
    this.keys.user = user;
    this.keys.tenant = tenant;
    this.keys.lastTenant = lastTenant;
  }

  saveSession(token, session, user, tenant, impersonated) {
    this.saveItemFun(this.storageProvider, `${this.prefix}-${this.keys.token}`, token);
    this.saveItemFun(this.storageProvider, `${this.prefix}-${this.keys.session}`, session);
    this.saveItemFun(this.storageProvider, `${this.prefix}-${this.keys.user}`, user);
    this.saveItemFun(this.storageProvider, `${this.prefix}-${this.keys.tenant}`, tenant);
    this.saveItemFun(this.storageProvider, `${this.prefix}-${this.keys.impersonated}`, impersonated);
  }

  removeSession() {
    this.removeItemFunc(this.storageProvider, `${this.prefix}-${this.keys.token}`);
    this.removeItemFunc(this.storageProvider, `${this.prefix}-${this.keys.session}`);
    this.removeItemFunc(this.storageProvider, `${this.prefix}-${this.keys.user}`);
    this.removeItemFunc(this.storageProvider, `${this.prefix}-${this.keys.tenant}`);
    this.removeItemFunc(this.storageProvider, `${this.prefix}-${this.keys.impersonated}`);
  }

  getToken() {
    return this.getItemFunc(this.storageProvider, `${this.prefix}-${this.keys.token}`);
  }

  getSession() {
    const sessionGetter = () => {
      const session = this.getItemFunc(this.storageProvider, `${this.prefix}-${this.keys.session}`);
      if (session === null) {
        return null;
      }

      session.expire = moment(session.expire);
      return session;
    };

    return {
      token: this.getToken(),
      session: sessionGetter(),
      user: this.getItemFunc(this.storageProvider, `${this.prefix}-${this.keys.user}`),
      tenant: this.getItemFunc(this.storageProvider, `${this.prefix}-${this.keys.tenant}`),
      impersonated: this.getItemFunc(this.storageProvider, `${this.prefix}-${this.keys.impersonated}`)
    };
  }

  saveLastTenant(lastTenant) {
    this.saveItemFun(this.storageProvider, `${this.prefix}-${this.keys.lastTenant}`, lastTenant);
  }

  getLastTenant() {
    return this.getItemFunc(this.storageProvider, `${this.prefix}-${this.keys.lastTenant}`);
  }
}
